import React from 'react';

import i18n from 'i18n';
import { isNotDefined } from 'utils/ramda';

import { useRecursive } from '../../../../functions';
import { MemoizedRecursiveSafariTableBrief } from '../index';
import { ITableProps } from '../types';
import { useAccommodationTable } from './functions';

export const AccommodationTable = ({ onReady = () => {} }: ITableProps) => {
  const { days, columns } = useAccommodationTable();
  const { innerPages, handleReady, handleFail } = useRecursive({ items: days, onReady });

  if (isNotDefined(days)) return null;

  return (
    <>
      {innerPages.map((p: any, i: number) => {
        return (
          <MemoizedRecursiveSafariTableBrief
            key={i}
            onReady={handleReady}
            onFail={handleFail}
            header={i18n.t('proposal_content.pdf.your_accommodations')}
            columns={columns}
            blocks={p}
            isLastPage={i === innerPages.length - 1}
          />
        );
      })}
    </>
  );
};
